<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 355 345"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    :style="transformStyle"
    v-bind="$attrs"
  >
    <mask
      id="mask0_39_897"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="59"
      y="19"
      width="229"
      height="290"
    >
      <path
        d="M137.994 19.2322L59.7276 99.1706L208.939 308.414L287.205 228.476L137.994 19.2322Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_39_897)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M267.677 248.47C257.439 206.525 233.475 179.759 196.584 172.858C186.466 171.822 174.915 171.819 163.107 171.323C142.506 170.469 118.001 168.54 102.383 151.239C82.049 128.714 80.2182 90.5083 99.4498 65.0494C112.438 47.8565 137.17 43.2247 150.873 57.9338C162.878 70.8163 161.9 89.7843 154.287 100.66C147.363 110.557 134.95 113.767 125.748 105.132C128.253 114.272 138.285 127.074 152.17 124.43C158.6 123.212 164.517 118.981 168.691 112.97C173.594 105.905 175.782 97.0856 175.711 88.1252C175.605 73.7814 168.984 60.8769 159.176 53.1434C139.532 37.6603 113.341 40.8237 96.7783 62.1599C75.9675 88.9627 78.1807 130.09 99.5517 154.124C117.095 173.854 139.978 174.62 162.894 175.532C174.666 176 186.347 176.055 197.106 177.232C234.376 183.624 252.823 209.075 267.677 248.47Z"
        fill="#9E0505"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M204.525 171.536C193.196 165.715 196.295 157.256 192.175 147.676C188.324 138.724 179.691 139.907 182.575 127.704C176.258 138.573 177.28 149.163 180.911 155.485C185.031 162.652 192.701 169.182 204.525 171.536Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M256.174 227.067C245.668 208.989 228.869 197.305 210.188 196.798C186.213 196.142 160.597 216.453 162.815 247.854C163.752 261.146 169.829 274.999 180.861 279.67C183.124 280.629 186.977 281.356 189.33 280.739C191.086 280.285 193.083 278.882 193.182 276.495C193.247 274.951 192.483 273.716 191.401 272.973C188.434 270.93 186.2 267.985 185.122 264.063C182.89 255.932 186.692 246.951 193.498 244.292C199.394 241.987 206.568 245.221 210.796 250.329C213.557 253.665 215.093 257.902 215.467 262.555C215.825 266.967 215.116 271.518 213.671 275.592C207.967 291.683 190.309 297.653 177.573 290.271C164.572 282.746 156.419 266.252 155.999 249.174C155.871 243.935 156.478 238.719 157.74 233.702C164.469 206.981 188.526 188.388 211.663 191.17C228.824 193.226 243.608 203.232 253.072 220.624C254.206 222.702 255.239 224.851 256.174 227.067Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M187.483 187.67C168.814 193.224 152.712 203.133 141.332 221.982C131.076 240.164 129.372 264.933 140.96 282.393C149.475 295.226 167.471 299.789 177.393 286.782C179.082 284.563 180.444 281.787 180.998 278.84C181.717 275.022 180.832 271.257 178.393 268.599C177.015 267.093 175.131 266.257 173.264 266.321C175.237 265.058 177.761 265.325 179.478 267.19C182.614 270.551 183.686 275.048 182.837 279.592C182.22 282.888 180.701 286.011 178.808 288.49C168.153 302.469 148.703 297.852 139.381 283.957C127.27 265.894 128.147 239.355 139.599 220.645C151.422 201.349 167.978 191.417 187.483 187.67Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M237.353 228.058C232.515 229.395 230.455 233.424 229.869 234.835C226.563 232.538 231.338 224.707 232.209 222.742C224.94 230.236 221.174 224.45 216.252 230.004C216.127 227.763 216.553 225.417 217.449 223.155C218.293 221.023 219.543 218.968 221.112 217.155C224.601 213.121 231.987 210.549 240.432 215.32C240.784 215.517 241.137 215.731 241.489 215.953C248.068 220.116 253.743 225.692 261.217 238.354C252.092 228.395 243.914 226.236 237.353 228.058Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M236.728 140.785C238.114 142.271 240.151 142.847 241.991 142.313C244.616 141.555 246.479 139.262 247.217 136.179C247.793 133.779 247.722 131.101 247.226 128.682C246.289 124.08 243.583 120.042 240.537 117.118C234.404 111.234 226.014 110.351 218.816 113.777C207.515 119.153 201.338 132.834 202.456 147.083C203.538 160.904 211.324 172.899 220.56 181.28C210.25 174.103 202.116 161.327 200.554 147.273C198.853 131.966 206.135 117.365 218.113 111.667C225.943 107.938 235.063 108.949 241.733 115.35C245.107 118.591 248.037 123.04 249.073 128.136C249.645 130.941 249.709 134.033 249.047 136.812C248.126 140.681 245.742 143.57 242.449 144.519C239.949 145.248 237.529 143.487 236.728 140.785Z"
      fill="#9E0505"
    />
    <path
      d="M227.285 184.378C216.891 174.156 211.195 160.502 215.157 149.756C217.91 142.295 221.729 140.009 224.223 140.172C225.666 140.27 226.852 140.667 227.798 141.265C226.933 141.612 226.12 142.259 225.48 143.164C225.05 143.764 224.614 144.666 224.399 145.492C223.688 148.211 224.507 151.127 226.491 152.37C228.689 153.744 231.493 152.571 232.843 149.748C233.805 148.168 234.126 145.788 232.779 142.474C229.11 133.428 214.306 132.795 210.997 149.788C208.151 164.411 216.451 176.399 227.285 184.378Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M90.1264 138.321C84.1791 125.413 77.4345 129.919 69.0528 125.948C61.2196 122.237 61.3702 111.859 51.4872 116.473C59.9266 107.902 68.8442 108.093 74.4622 111.797C80.834 116.003 87.0184 124.493 90.1264 138.321Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M81.3852 114.105C78.0719 104.392 72.9924 106.911 67.3378 103.277C62.0582 99.8808 62.8783 92.5575 55.5692 94.8448C62.1284 89.6169 68.4288 90.6301 72.1458 93.8057C76.3564 97.4076 80.1461 104.021 81.3852 114.105Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M243.658 196.85C239.038 183.182 246.23 179.801 248.953 169.537C251.498 159.946 244.667 153.516 253.909 147.302C243.014 149.682 237.495 158.052 236.348 165.591C235.047 174.14 236.646 185.227 243.658 196.85Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M70.7949 161.068C72.4587 161.347 73.7814 163.123 73.6598 165.267C73.5038 168.021 72.1569 170.266 70.0865 171.46C68.5986 172.312 66.8495 172.617 65.214 172.483C62.2331 172.236 59.3952 170.405 57.1854 168.068C52.8361 163.478 51.2071 156.244 52.3903 149.557C54.214 139.274 61.5472 131.779 70.3553 131.379C78.5463 131.007 86.7875 136.219 91.9913 143.843C86.202 137.267 78.4643 132.246 70.4678 132.981C62.3279 133.727 55.4215 140.193 53.7036 149.89C52.6159 156.014 54.0832 162.652 58.0694 166.87C60.0562 168.963 62.6261 170.661 65.3109 170.887C66.7204 170.999 68.2211 170.747 69.5028 170.015C71.1336 169.076 72.1996 167.331 72.3266 165.148C72.4123 163.589 71.8271 161.991 70.7949 161.068Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M169.769 232.257C174.784 225.473 182.178 221.951 189.716 222.632C190.454 214.308 200.642 205.916 213.398 203.447C212.295 203.332 211.186 203.255 210.072 203.223C193.463 202.772 175.313 213.741 169.769 232.257Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M90.9097 106.1C99.2291 121.844 109.68 131.026 122.074 132.482C121.441 143.849 133.16 158.347 152.637 165.415C128.453 168.723 104.717 151.596 95.0141 123.636C93.0506 117.976 91.6854 112.087 90.9097 106.1Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M163.428 135.734C166.844 132.884 170.566 134.357 169.735 138.413C178.302 135.043 172.337 120.378 160.865 125.257C144.722 132.121 149.455 164.167 173.553 167.098C162.455 163.016 150.631 146.398 163.428 135.734Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M85.5967 175.736C86.4992 179.631 89.4632 181.012 90.7001 177.963C94.5976 185.369 84.5262 190.847 79.4692 180.698C72.3478 166.411 89.1623 149.315 105.495 162.396C96.792 158.081 82.2123 161.151 85.5967 175.736Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M137.871 218.294C130.332 214.277 130.756 206.861 129.935 203.941C129.309 219.819 120.859 218.815 120.835 230.02C118.829 228.03 117.262 225.277 116.214 222.047C115.226 219 114.689 215.533 114.663 211.919C114.422 182.342 152.968 173.895 171.824 182.725C153.601 176.717 134.634 193.78 137.871 218.294Z"
      fill="#9E0505"
    />
    <path
      d="M261.799 225.025C258.53 214.958 258.962 204.725 264.249 200C267.921 196.721 270.788 196.884 272.206 197.969C273.022 198.589 273.608 199.289 273.995 200.012C273.392 199.871 272.738 199.931 272.113 200.207C271.695 200.393 271.193 200.75 270.838 201.145C269.672 202.456 269.346 204.48 270.167 205.992C271.074 207.662 273.041 208.078 274.61 206.962C275.611 206.419 276.454 205.148 276.582 202.68C276.929 195.942 268.432 189.745 261.802 198.383C256.103 205.813 257.658 216.098 261.799 225.025Z"
      fill="#9E0505"
    />
    <path
      d="M250.772 182.626C252.904 176.012 259.143 168.832 265.616 172.128C269.59 174.151 271.492 179.513 269.716 184.273C268.986 186.217 267.66 187.892 265.697 188.776C263.36 189.823 261.128 188.606 259.355 186.767C260.559 189.858 264.131 191.206 266.172 190.28C268.507 189.237 270.087 187.244 270.949 184.933C273.033 179.355 270.811 173.016 266.143 170.642C258.956 166.982 251.944 174.48 249.507 182.044C246.718 190.696 248.39 200.856 253.186 208.038C249.631 200.514 247.99 191.265 250.772 182.626Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M105.96 202.892C108.486 204.893 110.569 208.663 110.27 212.215C109.91 216.506 108.236 220.297 105.423 223.016C99.2097 229.015 90.2279 227.547 85.3435 220.074C77.7696 208.483 84.5473 192.51 93.2488 184.956C101.371 177.916 112.047 175.863 121.772 178.471C112.094 177.131 101.993 179.263 94.0036 186.194C85.9027 193.22 79.2363 208.259 86.3416 219.134C90.7997 225.957 98.9466 227.308 104.624 221.83C107.166 219.374 108.685 215.941 109.009 212.054C109.314 208.426 108.01 205.346 105.96 202.892Z"
      fill="#9E0505"
    />
    <path
      d="M79.7157 97.9722C80.9516 87.2752 78.5502 77.4395 72.4935 74.2867C68.2857 72.0956 65.526 73.0434 64.3607 74.4831C63.6789 75.3137 63.2471 76.1541 63.0098 76.964C63.569 76.6651 64.2188 76.5384 64.8767 76.6423C65.3215 76.7053 65.8793 76.9112 66.3032 77.202C67.6889 78.1583 68.398 80.0433 67.8925 81.7334C67.3336 83.6135 65.5018 84.5514 63.758 83.8956C62.6791 83.6335 61.614 82.6343 61.0124 80.2719C59.3704 73.8062 66.443 65.4471 74.5604 72.044C81.5439 77.7119 82.0222 88.146 79.7157 97.9722Z"
      fill="#9E0505"
    />
    <path
      d="M142.404 55.2307C149.236 62.3121 152.86 71.5981 150.044 78.7293C148.089 83.685 145.488 85.1424 143.817 84.981C142.849 84.8826 142.058 84.5919 141.433 84.1707C142.021 83.9581 142.574 83.5367 143.018 82.9483C143.313 82.5512 143.62 81.9534 143.777 81.4005C144.296 79.5932 143.785 77.6225 142.47 76.7425C141.015 75.7727 139.115 76.5023 138.166 78.3734C137.497 79.4107 137.249 80.9997 138.103 83.2536C140.436 89.4085 150.367 90.1413 152.839 78.7913C154.962 69.0418 149.565 60.8143 142.404 55.2307Z"
      fill="#9E0505"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M112.775 86.4297C114.029 89.7278 116.819 92.7775 119.802 92.9828C123.407 93.2327 126.804 91.8541 129.494 88.9634C135.43 82.5762 135.628 71.7498 130.218 64.8131C121.825 54.0562 107.555 59.5411 99.9454 68.6156C92.8445 77.0938 89.4694 89.3649 90.0998 101.245C90.5139 89.6169 93.8607 78.0396 100.85 69.7006C107.929 61.2516 121.41 55.7513 129.284 65.8428C134.221 72.1706 134.06 81.9975 128.639 87.8274C126.207 90.4429 123.135 91.6956 119.87 91.4673C116.82 91.2592 114.478 89.2374 112.775 86.4297Z"
      fill="#9E0505"
    />
  </svg>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  orientation: {
    type: String,
    default: "normal", // options: 'normal', 'flip-horizontal', 'flip-vertical', 'flip-both'
  },
  width: {
    type: Number,
    default: 328,
  },
  height: {
    type: Number,
    default: 334,
  },
});

const transformStyle = computed(() => {
  switch (props.orientation) {
    case "flip-horizontal":
      return "transform: scaleX(-1); transform-origin: center;";
    case "flip-vertical":
      return "transform: scaleY(-1); transform-origin: center;";
    case "flip-both":
      return "transform: scale(-1, -1); transform-origin: center;";
    case "left":
      return "transform: scaleX(-1) rotate(-45deg) scale(1.4); transform-origin: center;";
    case "right":
      return "transform: scaleX(1) rotate(-45deg) scale(1.4); transform-origin: center;";
    default:
      return "";
  }
});
</script>
